
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 17">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.5993 0C14.0395 0 14.3956 0.361586 14.3956 0.80724V3.22806H17.1889C17.7316 3.22806 17.9771 3.52911 18.2961 3.92038C18.3267 3.95792 18.358 3.99629 18.3903 4.0353L20.1729 7.26245C20.1729 7.26245 20.7785 8.14291 20.7912 8.91399V12.961C20.7926 13.1737 20.7095 13.3782 20.5602 13.5296C20.4108 13.681 20.2075 13.7668 19.9948 13.7683H19.1993C18.9959 12.3707 17.819 11.2869 16.3925 11.2869C14.9552 11.2869 13.7891 12.3707 13.5875 13.7683H8.0001C7.79671 12.3707 6.6324 11.2869 5.1942 11.2869C3.75509 11.2869 2.57812 12.3707 2.38829 13.7683H0.795507C0.353026 13.7648 -0.002988 13.4035 1.89078e-05 12.961V0.80724C1.89078e-05 0.361586 0.356181 0 0.797315 0H13.5993ZM6.92981 14.081C6.92981 12.8815 6.08641 11.8907 5.04052 11.8907H5.03962C3.99464 11.8907 3.15033 12.8688 3.15033 14.081C3.15033 15.2942 3.99464 16.2714 5.04052 16.2714C6.08641 16.2714 6.92981 15.2924 6.92981 14.081ZM18.2709 14.081C18.2709 12.8815 17.4266 11.8907 16.3808 11.8907C15.3349 11.8907 14.4906 12.8688 14.4906 14.081C14.4906 15.2942 15.3349 16.2714 16.3817 16.2714C17.4266 16.2714 18.2709 15.2924 18.2709 14.081ZM15.192 4.85429H17.1536C17.2847 4.85429 17.4628 5.04683 17.4628 5.04683L19.1514 8.21432C19.306 8.43127 19.4597 8.69704 19.4597 8.90133H15.192V4.85429Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Receiving',
    }) as DefineComponent
    </script>
    